import './styles/index.scss';
// import AOS from 'aos';

// // Thirdparty
// import 'what-input';
// import $ from 'jquery';
// window.jQuery = $;
// window.$ = $;

document.addEventListener('DOMContentLoaded', () => {
  const userAgent = navigator.userAgent;
  const re = /Safari/;
  if (re.test(userAgent)) {
    const typekit = document.createElement('link');
    typekit.rel = 'stylesheet';
    typekit.href = '//use.typekit.net/gqb2xef.css';
    document.head.appendChild(typekit);
  }
});

/*
* Script loader
*
* Imports and runs all scripts in the `./scripts` directory
* Scripts must have a default export with `can` and `run` functions
*
*    export default {
*      can: () => boolean,
*      run: function to run if `can` is true
*    }
*/
document.addEventListener('DOMContentLoaded', () => {
  (r => {
    r
      .keys()
      .reduce((modules, script) => {
        const module = r(script).default;
        module && modules.push(module);
        return modules;
      }, [])
      .map(module => (module.can === true || module.can()) && module.run());
  })(require.context('scripts', true, /^(?!.*(common)).*\.js$/));
});

document.body.classList.remove('preload');
